import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { onboardingMainFormFieldsSelector } from '../redux';

export const FormWrapper = ({ children, handleSubmitForm, formValidation }) => {
  const mainFormFields = useSelector(onboardingMainFormFieldsSelector);

  const initialFormFields = mainFormFields.reduce((acc, field) => {
    if (field.data) {
      const fieldsGroup = field.data.map((fieldGroup) => {
        const subFields = fieldGroup.reduce((fieldGroupAcc, currentField) => {
          fieldGroupAcc[currentField.name] = currentField.value;

          return fieldGroupAcc;
        }, {});

        return subFields;
      });

      acc[field.name] = fieldsGroup;
      return acc;
    }

    acc[field.name] = field.value;
    return acc;
  }, {});

  return (
    <Formik
      initialValues={initialFormFields}
      onSubmit={handleSubmitForm}
      validationSchema={formValidation(mainFormFields)}
      enableReinitialize
      validateOnMount
    >
      {children}
    </Formik>
  );
};

FormWrapper.propTypes = {
  children: PropTypes.func.isRequired,
  handleSubmitForm: PropTypes.func.isRequired,
  formValidation: PropTypes.func.isRequired,
};
